export default __webpack_public_path__ + "static/media/Schaltschrank_mit_Gera╠êten_komplett.cb0a3230.png";